<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <div>
          <h1 class="sci-page-title-only">Relatório de Abastecimentos Bloqueados</h1>
          <p class="text-sm text-slate-500 font-medium mt-1">Busque, gere relatórios e delete abastecimentos bloqueados</p>
        </div>
      </div>

      <!-- BUSCAR FORM -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
          <v-icon color="orange" small>mdi-filter-outline</v-icon>
          <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">FILTROS DE BUSCA</h2>
        </div>
        <div class="p-8">
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
              <Date @dateValue="[(filter.startDate = $event)]" />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
              <Date @dateValue="[(filter.endDate = $event)]" />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Prefeitura</label>
              <v-autocomplete
                v-model="filter.prefecture_id"
                :items="prefectures"
                item-text="prefecture_social_name"
                item-value="prefecture_id"
                clearable outlined dense hide-details="auto" class="bg-slate-50"
                :disabled="($store.getters.getUserData.group_id != 1 && $store.getters.getUserData.group_id != 5) && $store.getters.getUserData.table_key == 'prefectures'"
                @change="getProviders(filter.prefecture_id)"
                placeholder="Selecione a prefeitura"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
               <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mt-4 mb-2">Participante</label>
               <v-autocomplete
                 v-model="filter.provider_id"
                 :items="providers"
                 item-text="provider_name"
                 item-value="provider_id"
                 clearable outlined dense hide-details="auto" class="bg-slate-50"
                 placeholder="Selecione o participante"
               />
            </v-col>
          </v-row>
        </div>
        <div class="px-8 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
          <v-btn text :loading="loader" v-if="loader"></v-btn>
          <button
            class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 flex items-center justify-center gap-2 w-fit whitespace-nowrap px-8 h-10 transition-all transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed text-[11px] font-bold uppercase tracking-widest"
            @click="getData"
            :disabled="!(filter.startDate && filter.endDate && filter.prefecture_id)"
          >
            FILTRAR
          </button>
        </div>
      </div>

      <!-- LISTAGEM -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-format-list-bulleted</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ABASTECIMENTOS BLOQUEADOS</h2>
          </div>
          <div class="flex items-center gap-4">
              <v-btn
                text dark
                :disabled="supplies.length === 0"
                :to="`/report/master/blocked/${filter.startDate}/${filter.endDate}/${filter.prefecture_id}/${filter.provider_id}`"
                class="text-[11px] tracking-widest font-bold h-10 px-6 rounded-lg"
                color="orange"
              >
                GERAR RELATÓRIO
              </v-btn>
              <button
                v-if="$store.getters.getUserData.table_key !== 'prefectures'"
                @click="dropSupplies"
                :disabled="selectedSupplies.length === 0"
                class="text-[11px] font-bold uppercase tracking-widest text-red-400 hover:text-red-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-slate-800 px-6 h-10 rounded-lg shadow-md hover:bg-slate-900 transition-all ml-2"
              >
                DELETAR SELECIONADOS
              </button>
          </div>
        </div>
        
        <div class="p-0 text-sm">
          <v-data-table
            :items="supplies"
            :headers="headers"
            :loading="loader"
            :show-select="$store.getters.getUserData.table_key !== 'prefectures'"
            item-key="supply_id"
            v-model="selectedSupplies"
            class="elevation-0"
          >
            <template v-slot:item.datehour="{ item }">
              <span>{{ convertDateTime(item.datehour) }}</span>
            </template>
            <template v-slot:item.supply_liters_stocked="{ item }">
              <span>{{ item.supply_liters_stocked ? realMaskII(item.supply_liters_stocked) : 0 }}</span>
            </template>
            <template v-slot:item.supply_bidding_price="{ item }">
              <span>{{ item.supply_bidding_price ? realMaskII(item.supply_bidding_price) : 0 }}</span>
            </template>
            <template v-slot:item.total_billing_price="{ item }">
              <span>{{ item.supply_bidding_price && item.supply_liters_stocked ? realMask(Number(item.supply_bidding_price * item.supply_liters_stocked).toFixed(2)) : 0 }}</span>
            </template>
            <template v-slot:item.supply_status="{ item }">
              <div class="flex items-center gap-2">
                 <div :class="`w-1.5 h-1.5 rounded-full ${item.supply_status === 'CONCLUIDO' ? 'bg-emerald-500' : 'bg-orange-500'}`"></div>
                 <span :class="`text-[9px] font-black uppercase tracking-widest ${item.supply_status === 'CONCLUIDO' ? 'text-emerald-600' : 'text-orange-600'}`">{{ item.supply_status }}</span>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="flex items-center gap-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="blue" v-bind="attrs" v-on="on" @click="openEdit(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.supply_status !== 'CONCLUIDO'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="success" v-bind="attrs" v-on="on" @click="conferSupply(item)">
                      <v-icon small>mdi-check-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Conferido</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>

        <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center gap-6">
          <span class="text-[11px] font-bold text-slate-500 uppercase tracking-widest">Total Licitado: <span class="text-slate-900 ml-1">R$ {{ totals.bidding_total ? realMask(Number(totals.bidding_total).toFixed(2)) : 0 }}</span></span>
        </div>
      </div>

      <!-- DIALOG EDITAR -->
      <v-dialog v-model="editDialog" width="600">
        <v-card class="rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
          <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
            <div class="flex items-center gap-3">
              <v-icon color="orange" small>mdi-pencil-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">EDITAR ABASTECIMENTO BLOQUEADO</h2>
            </div>
            <v-btn icon dark small @click="editDialog = false"><v-icon small>mdi-close</v-icon></v-btn>
          </div>
          <div class="p-8 bg-white">
            <v-form ref="editForm">
              <v-row dense>
                <v-col cols="12" md="4">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Volume (Litros)</label>
                  <v-text-field v-model="editData.supply_liters_stocked" v-mask-decimal.br="3" @change="calculateTotals" outlined dense hide-details class="bg-slate-50 rounded-lg" prepend-inner-icon="mdi-opacity" />
                </v-col>
                <v-col cols="12" md="12">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Item / Combustível</label>
                  <v-text-field v-model="editData.item_description_desc" readonly outlined dense hide-details class="bg-slate-100 rounded-lg font-bold" prepend-inner-icon="mdi-fuel" />
                </v-col>
                <v-col cols="12" md="4">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Preço Licitado</label>
                  <v-text-field v-model="editData.supply_bidding_price" v-mask-decimal.br="3" @change="calculateTotals" outlined dense hide-details class="bg-slate-50 rounded-lg" prepend-inner-icon="mdi-cash" />
                </v-col>
                <v-col cols="12" md="4">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Valor Total</label>
                  <v-text-field readonly v-model="editData.supply_value" v-mask-decimal.br="2" outlined dense hide-details class="bg-slate-50 rounded-lg font-black text-orange-600" prefix="R$" />
                </v-col>
                <v-col cols="12" md="6" class="mt-4">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Cupom / NF-e</label>
                  <v-text-field v-model="editData.supply_coupon" outlined dense hide-details class="bg-slate-50 rounded-lg" prepend-inner-icon="mdi-barcode-scan" />
                </v-col>
                <v-col cols="12" md="6" class="mt-4">
                  <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Justificativa</label>
                  <v-textarea v-model="editData.justificativa" outlined dense hide-details class="bg-slate-50 rounded-lg" rows="3" />
                </v-col>
              </v-row>
            </v-form>
            <div class="mt-8 flex justify-end gap-3 pt-6 border-t border-slate-100">
              <v-btn text @click="editDialog = false" class="text-[11px] font-bold tracking-widest uppercase">Cancelar</v-btn>
              <v-btn color="orange" dark depressed @click="updateSupply" class="text-[11px] font-bold tracking-widest uppercase px-8 h-12 rounded-xl shadow-lg shadow-orange-500/20">Salvar Alterações</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      
    </div>
    
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    providers: [],
    items: [],
    selectedSupplies: [],
    filter: {
      prefecture_id: null,
      provider_id: null,
      startDate: null,
      endDate: null,
    },
    totals: {
      bidding_total: 0,
      day_value: 0,
      billing_price: 0,
    },
    supplies: [],
    headers: [
      { text: "Data/Hora", value: "datehour" },
      { text: "Item", value: "item_description_desc" },
      { text: "Lts Abastecidos", value: "supply_liters_stocked" },
      { text: "Preço Licitado", value: "supply_bidding_price" },
      { text: "T. Licitado", value: "total_billing_price" },
      { text: "Senha", value: "supply_code" },
      { text: "Status", value: "supply_status" },
      { text: "Número da NF-e", value: "supply_coupon" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    editDialog: false,
    editData: {
      supply_id: null,
      supply_liters_stocked: "0,000",
      supply_price_day: "0,000",
      supply_value: "0,00",
      supply_coupon: "",
      justificativa: ""
    },
    loader: false,
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    if(this.$store.getters.getUserData.table_key == 'prefectures') {
      this.filter.prefecture_id = this.$store.getters.getUserData.table_id
      this.getProviders(this.filter.prefecture_id);
    }
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;

      // Auto-seleciona se houver apenas uma prefeitura (comum para administradores restritos)
      if (this.prefectures.length === 1 && !this.filter.prefecture_id) {
        this.filter.prefecture_id = this.prefectures[0].prefecture_id;
        this.getProviders(this.filter.prefecture_id);
      }

      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    conferSupply(item) {
      let c = confirm("Deseja marcar este abastecimento como CONFERIDO? Ele passará a constar nos relatórios operacionais.");
      if (c) {
        this.loader = true;
        this.$store.dispatch("setLoader", true);
        const updateData = { ...item, supply_status: "CONCLUIDO", supply_confered: true };
        this.$http.put(`/supplies/single/${item.supply_id}`, updateData).then(() => {
          this.snack.message = "Abastecimento conferido com sucesso!";
          this.snack.color = "success";
          this.snack.show = true;
          this.loader = false;
          this.getData();
          this.$store.dispatch("setLoader", false);
        }).catch((e) => {
          this.snack.message = e.message;
          this.snack.color = "error";
          this.snack.show = true;
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
      }
    },
    openEdit(item) {
      this.editData = JSON.parse(JSON.stringify(item));
      const price = parseFloat(item.supply_price_day) || parseFloat(item.supply_bidding_price) || 0;
      this.editData.supply_liters_stocked = Number(item.supply_liters_stocked || 0).toFixed(3).replace('.', ',');
      this.editData.supply_bidding_price = price.toFixed(3).replace('.', ',');
      this.editData.supply_value = Number(item.supply_value || (price * parseFloat(item.supply_liters_stocked || 0)) || 0).toFixed(2).replace('.', ',');
      this.editDialog = true;
    },
    calculateTotals() {
      const l = this.convertDecimalNumberII(this.editData.supply_liters_stocked || 0);
      const p = this.convertDecimalNumberII(this.editData.supply_bidding_price || 0);
      this.editData.supply_value = Number(l * p).toFixed(2).replace('.', ',');
    },
    updateSupply() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      this.$http.put(`/supplies/single/${this.editData.supply_id}`, this.editData).then(() => {
        this.snack.message = "Registro atualizado com sucesso!";
        this.snack.color = "success";
        this.snack.show = true;
        this.editDialog = false;
        this.loader = false;
        this.getData();
        this.$store.dispatch("setLoader", false);
      }).catch((e) => {
        this.snack.message = e.message;
        this.snack.color = "error";
        this.snack.show = true;
        this.loader = false;
        this.$store.dispatch("setLoader", false);
      });
    },
    getProviders(id) {
      this.$http.get(`/providers/prefecture/${id}`).then((r) => {
        this.providers = r.data;
        this.loader = false;
        this.$store.dispatch("setLoader", this.loader);
      });
    },
    dropSupplies() {
      let c = confirm("Deseja excluir os abastecimentos selecionados?");
      if (c) {
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/supplies/blocked/delete", {
            selectedSupplies: this.selectedSupplies,
          })
          .then((r) => {
            this.snack.message = r.data.result;
            this.loader = false;
            this.getData();
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    getData() {
      if (this.filter.prefecture_id) {
        this.totals.day_value = 0;
        this.totals.bidding_total = 0;
        this.supplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/supplies/blocked`, this.filter)
          .then((response) => {
            const mappedSupplies = response.data.map((supply) => {
              return {
                ...supply,
                supply_liters_stocked: Number(supply.supply_liters_stocked || 0).toFixed(3),
                supply_bidding_price: Number(supply.supply_bidding_price || 0).toFixed(3),
                supply_price_day: Number(supply.supply_price_day || 0).toFixed(3),
              };
            });

            this.supplies = mappedSupplies;
            
            // Calcula totais
            let dayValue = 0;
            let biddingTotal = 0;
            response.data.forEach(supply => {
              dayValue += parseFloat(supply.supply_value || 0);
              biddingTotal += parseFloat(supply.supply_bidding_value || 0);
            });
            
            this.totals.day_value = dayValue;
            this.totals.bidding_total = biddingTotal;

            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>